import React, {useEffect, useRef} from 'react';
import { defineBlock, smartProps, useEditor, ChildrenBlock, useSmartProp, useInspectorControl } from '@smartfire/wordpress-react';
import { InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';
import style from './block.module.scss';

const Inspector = () => {
    const [urlParam, setUrlParam] = useSmartProp('urlParam')
    const [tabLibelle, setTabLibelle] = useSmartProp('tabLibelle')

    return <PanelBody title={'options'} initialOpen={true}>
        <PanelRow>
            <TextControl
                label="Libellé de l'onglet"
                value={tabLibelle}
                onChange={setTabLibelle}
            />
        </PanelRow>
        <PanelRow>
            <TextControl
                label="Paramètre url"
                value={urlParam}
                onChange={setUrlParam}
            />
        </PanelRow>
    </PanelBody>
}

const Tab = ({ urlParam, tabLibelle }) => {
    const { isEditing } = useEditor();
    useInspectorControl( Inspector );
    const ref = useRef();

    useEffect(() => {
        if (ref.current) {
            const refElt = (ref.current.parentNode.parentNode)
            refElt.setAttribute('data-param', urlParam)
            refElt.setAttribute('data-text', tabLibelle)
        }
    }, [ref, urlParam, tabLibelle])

    return <div className={style.block} data-param={urlParam} data-text={tabLibelle} ref={ref}>
        <div className={style.container}>
            {isEditing ? 
                <>
                    <div>Onglet</div>
                    <InnerBlocks />
                </>
            :
                <ChildrenBlock />
            }
        </div>
    </div>
}

export default defineBlock ({
    Block: Tab,
    smartProps: {
        urlParam: smartProps.string.withDefault(''),
        tabLibelle: smartProps.string.withDefault('libellé de l\'onglet')
    },
    setup: {
        title: 'Onglet',
        parent: ['smartfire/tabs']
    }
})